<template>
  <section class="section-index-table">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 col-md-4 col-lg-3">
          <div class="main-sort select-arrows">
            <select v-model="sort">
              <option :value="null">По умолчанию</option>
              <option v-for="option in sortOptions" :key="option.text" v-bind:value="option">
                {{ option.text }}
              </option>
            </select>
          </div>
          <div class="main-sort select-arrows">
            <select v-model="selectedRegion">
              <option :value="null">Все</option>
              <option :key="region" v-for="region in regions" :value="region">
                {{ region }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div v-for="station in sortByRegionName(stations)" :key="station.id" class="row main-stations">
        <div class="col-12 main-stations__col">
          <div class="row">
            <div class="col-12 main-stations-col-type-1">
              <div class="main-stations__type1">
                <img v-if="station.signal" class="main-stations__signal" src="../../assets/images/img-svg/signal-1.svg" alt="">
                <img v-else class="main-stations__signal" src="../../assets/images/img-svg/signal-2.svg" alt="">
                <div class="main-stations__edit">
                  <span class="edit" @click="openEdit(station.id)"></span>
                </div>
                <a class="main-stations__name" target="_blank" :href="'/station-view/' + station.id">{{station.name}} ({{station.totalPower}} MW)</a>
                <div class="main-stations__region">{{station.region}} обл.</div>
                <div class="main-stations__date">
                  <span class="date">{{ formatDateTime(station.lastUpdate) }}</span>
                  <span v-if="isRestricting(station)" class="power"><i></i>{{restrictions[station.id]}} kW</span>
                </div>
                <div class="main-stations__power">
                  <div class="main-stations__power_all">
                    <div class="name">Мощность kW</div>
                    <div class="data-wrapp">
                      <div class="data">Cейчас: <span>{{ round(station.currentPower) }}</span></div>
                      <div class="data">Пик: <span>{{ round(station.powerPeak) }}</span></div>
                    </div>
                  </div>
                  <div class="main-stations__power_today">
                    <div class="name">kWh сегодня</div>
                    <div class="data-wrapp">
                      <div class="data"><span>{{ round(station.powerDay) }}</span></div>
                    </div>
                  </div>
                </div>
                <div class="main-stations__graph first">
                  <div class="line"><div :style="{ 'width': loadPercent(station) + '%' }"></div></div>
                  <span class="percent">{{loadPercent(station)}}%</span>
                </div>
<!--                <div class="main-stations__graph second">-->
<!--                  <div class="line"><div style="width:75%;"></div></div>-->
<!--                  <span class="percent">75%</span>-->
<!--                </div>-->
              </div>
            </div>
            <div class="col-12 col-md-7 col-lg main-stations-col-type-2">
              <Inverters :station="station"></Inverters>
            </div>
            <div class="col-12 main-stations-col-type-3">
              <Lines :station="station"></Lines>
            </div>
            <div class="col-12 main-stations-col-type-4">
              <Insolation :station="station"></Insolation>
            </div>
          </div>
        </div>
      </div>
    </div>
    <InverterModal></InverterModal>
  </section>
</template>

<script>
import moment from 'moment'
import collection from 'lodash/collection'
import StationAPI from '../../api/station'
import Inverters from '@/components/stations/table/Inverters'
import Lines from '@/components/stations/table/Lines'
import Insolation from '@/components/stations/table/Insolation'
import InverterModal from '@/components/stations/table/InverterModal'
import Vue from 'vue'

function autoLayoutKeyboard (str) {
  const replacer = {
    'q': 'й',
    'w': 'ц',
    'e': 'у',
    'r': 'к',
    't': 'е',
    'y': 'н',
    'u': 'г',
    'i': 'ш',
    'o': 'щ',
    'p': 'з',
    '[': 'х',
    ']': 'ї',
    'a': 'ф',
    's': 'і',
    'd': 'в',
    'f': 'а',
    'g': 'п',
    'h': 'р',
    'j': 'о',
    'k': 'л',
    'l': 'д',
    ';': 'ж',
    '\'': 'є',
    'z': 'я',
    'x': 'ч',
    'c': 'с',
    'v': 'м',
    'b': 'и',
    'n': 'т',
    'm': 'ь',
    ',': 'б',
    '.': 'ю',
    '/': '.'
  }

  // noinspection PhpCoveredCharacterInClassInspection
  return str.replace(/[A-z/,.;\'\]\[]/g, x => {
    return x === x.toLowerCase() ? replacer[ x ] : replacer[ x.toLowerCase() ]
  })
}

export default {
  name: 'StationTable',
  components: {
    InverterModal,
    Insolation,
    Lines,
    Inverters
  },
  data () {
    return {
      stations: null,
      polling: null,
      regions: [],
      selectedRegion: null,
      sort: null,
      restrictable: null,
      restrictions: {},
      restrictionsPolling: null,
      sortOptions: [
        {
          text: 'По названию от А до Я',
          iteratees: 'name',
          orders: 'asc'
        },
        {
          text: 'По названию от Я до А',
          iteratees: 'name',
          orders: 'desc'
        },
        {
          text: 'По области от А до Я',
          iteratees: ['region', 'name'],
          orders: ['asc', 'asc']
        },
        {
          text: 'По области от Я до А',
          iteratees: ['region', 'name'],
          orders: ['desc', 'desc']
        }
      ]
    }
  },
  computed: {
    isLoading () {
      return this.$store.getters[ 'station/isLoading' ]
    },
    hasError () {
      return this.$store.getters[ 'station/hasError' ]
    },
    error () {
      return this.$store.getters[ 'station/error' ]
    },
    user () {
      return this.$store.getters[ 'user/hasUser' ] ? this.$store.getters[ 'user/user' ] : {
        isSuper: false
      }
    },
    searchName () {
      return this.$store.getters['common/search']
    }
  },
  created () {
    let _this = this

    StationAPI.findAll()
      .then((r) => {
        _this.stations = r.data

        _this.polling = setInterval(() => {
          StationAPI.findAll()
            .then((r) => {
              _this.stations = r.data
            })
        }, 1000 * 15)

        _this.loadRegions()
      })

    this.fetchRestrictable()
  },
  beforeDestroy () {
    clearInterval(this.polling)
    clearInterval(this.restrictionsPolling)
  },
  methods: {
    translate (val) {
      return autoLayoutKeyboard(val)
    },
    isRestricting (s) {
      return this.restrictions.hasOwnProperty(s.id) && (Number(this.restrictions[s.id]) < (parseFloat(String(s.totalPower).replace(',', '.')) * 1000))
    },
    fetchRestrictable () {
      StationAPI.findRestrictable().then(r => {
        this.restrictable = r.data
        this.fetchRestrictions()
        this.restrictionsPolling = setInterval(this.fetchRestrictions, 45 * 1000)
      })
    },
    fetchRestrictions () {
      this.restrictable.forEach(s => {
        StationAPI.findStationRestriction(s.id).then(r => {
          Vue.set(this.restrictions, s.id, r.data.value)
        })
      })
    },
    round (val) {
      return Math.round(val)
    },
    loadPercent (station) {
      return Math.round(100 * station.currentPower / (parseFloat(String(station.totalPower).replace(',', '.')) * 1000))
    },
    loadRegions () {
      let values = []
      this.stations.forEach(station => {
        values.push(station.region)
      })
      this.regions = values.filter((value, index, self) => {
        return self.indexOf(value) === index
      })
    },
    sortByRegionName (stations) {
      let result
      if (this.sort === null) {
        result = collection.orderBy(stations, [
          'region',
          'name'
        ], [
          'asc',
          'asc'
        ])
      } else {
        result = collection.orderBy(stations, this.sort.iteratees, this.sort.orders)
      }

      if (!(this.selectedRegion === null)) {
        result = result.filter(station => station.region === this.selectedRegion)
      }

      if (this.searchName.length > 0) {
        const word = autoLayoutKeyboard(this.searchName.toLowerCase())

        result = result.filter(station => station.name.toLowerCase()
          .includes(word))
      }
      return result
    },
    openEdit (id) {
      this.$router.push({
        name: 'station-edit',
        params: { id: id }
      })
    },
    showStation (id) {
      this.$router.push({
        name: 'station-view',
        params: { id: id }
      })
    },
    formatDateTime (timestamp) {
      return moment.unix(timestamp)
        .format('DD.MM.YYYY HH:mm')
    }
  }
}
</script>
